// src/services/axios/AuthApis/NotificationApis.js
import apiConfig from "../ApiConfig";

const BASE = "/api/notifications";

/**
 * Fetch notifications for a user.
 * @param {string} userId
 * @param {object} params  - { is_read, page, page_size, module }
 */
export const getNotificationsApi = async (userId, params = {}) => {
  const q = new URLSearchParams({ to_user_id: userId });
  if (params.is_read !== undefined) q.append("is_read", params.is_read);
  if (params.page) q.append("page", params.page);
  if (params.page_size) q.append("page_size", params.page_size);
  if (params.module) q.append("module", params.module);
  const { data } = await apiConfig.get(`${BASE}/?${q}`);
  return data;
};

/**
 * Get only the unread badge count (lightweight poll).
 * @param {string} userId
 */
export const getUnreadCountApi = async (userId) => {
  const { data } = await apiConfig.get(`${BASE}/unread-count/?to_user_id=${userId}`);
  return data.unread_count ?? 0;
};

/**
 * Mark a single notification as read.
 * @param {string} notificationId
 */
export const markReadApi = async (notificationId) => {
  const { data } = await apiConfig.put(`${BASE}/${notificationId}/read/`);
  return data;
};

/**
 * Mark all notifications as read for a user. Pass `module` to scope the
 * operation to a single module's notifications only.
 * @param {string} userId
 * @param {string} [module]
 */
export const markAllReadApi = async (userId, module) => {
  const q = new URLSearchParams({ to_user_id: userId });
  if (module) q.append("module", module);
  const { data } = await apiConfig.put(`${BASE}/read-all/?${q}`);
  return data;
};

/**
 * Soft-delete a single notification.
 * @param {string} notificationId
 */
export const deleteNotificationApi = async (notificationId) => {
  const { data } = await apiConfig.delete(`${BASE}/${notificationId}/`);
  return data;
};

/**
 * Soft-delete all notifications for a user. Pass `module` to scope the
 * clear to a single module's notifications only.
 * @param {string} userId
 * @param {string} [module]
 */
export const clearAllNotificationsApi = async (userId, module) => {
  const q = new URLSearchParams({ to_user_id: userId });
  if (module) q.append("module", module);
  const { data } = await apiConfig.delete(`${BASE}/clear-all/?${q}`);
  return data;
};
